export default {"src":"/_next/static/media/signup_icon_2.5ded501c.svg","height":32,"width":26};